import axios from 'axios';

// Global axios instance configured with base URL
export const api = axios.create({
  baseURL: 'https://ittech-api.onrender.com',
  // baseURL: 'https://rested-jolly-oriole.ngrok-free.app',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interface for checkout session response
interface CreateCheckoutSessionResponse {
  sessionId: string;
  url: string;
}

// Function to create Stripe checkout session for subscription
export const createStripeCheckoutSession = async (
  productId: string,
  priceId: string,
  successUrl: string,
  cancelUrl: string,
  quantity: number = 1,
  metadata?: Record<string, any>
): Promise<CreateCheckoutSessionResponse> => {
  try {
    const response = await api.post<CreateCheckoutSessionResponse>(
      '/stripe/create-paid-checkout-session-subscription',
      {
        product_id: productId,
        price_id: priceId,
        quantity: quantity,
        success_url: successUrl,
        cancel_url: cancelUrl,
        metadata: metadata,
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

export default api;
